/**
 * Central field-length policy for string inputs (single source for the FE).
 *
 * Mirrors the backend `validation/FieldLengths` (NEX-450/451/452) until the
 * OpenAPI client generation is in place and these values can be derived.
 * Until then, keep both in sync manually — these are the real input limits.
 */
export const FIELD_LENGTHS = {
  /** Name/title class: name, title, displayLabel, contactPerson, domain, extId, azureTenantId. */
  NAME_MAX: 255,
  /** Free-text class: description, notes, testGoal, preconditions, postconditions, action, expectedResult, tags. */
  FREETEXT_MAX: 20000,
  /** URL/Ref class: URLs and similar. */
  URL_MAX: 2048,
  /** Code/Key class: version, jiraKey, icon and similar short identifiers. */
  KEY_MAX: 50,
  /**
   * Very short code class: projectKey and similar. Mirrors the backend column
   * `project_integration.project_key`; the tighter Redmine limit for the internal
   * connection alias lives in the project form (NEX-969), not here.
   */
  SHORT_CODE_MAX: 20,
  /** Email class: login/invite addresses. Mirrors RFC-5321-based BE cap. */
  EMAIL_MAX: 254,
  /** Reference/path class: automation script/locator reference on a test case. */
  AUTOMATION_LOCATOR_MAX: 1000,
  /** Begruendung eines Testlauf-Abbruchs; spiegelt `FieldLengths.ABORT_REASON_MAX` (NEX-1314). */
  ABORT_REASON_MAX: 1000,
  /** Kommentar zur Freigabe-Entscheidung eines Releases; spiegelt die 2000-Zeichen-Grenze des BE (NEX-1463). */
  DECISION_COMMENT_MAX: 2000,
  /** Hinweis an die KI bei Testfall-Vorschlägen; spiegelt `FieldLengths.KI_HINWEIS_MAX` (NEX-1538). */
  KI_HINWEIS_MAX: 500,
  /** Höchste Schrittnummer je KI-Qualitätscheck; spiegelt `FieldLengths.KI_QUALITAET_SCHRITTE_MAX`. */
  KI_QUALITAET_SCHRITTE_MAX: 200,
  /** Zeichen je KI-Qualitätscheck über alle Texte; spiegelt `FieldLengths.KI_QUALITAET_ZEICHEN_MAX`. */
  KI_QUALITAET_ZEICHEN_MAX: 200_000,
} as const;
